import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { navigateTo } from "gatsby-link"
import { Container, Row, Col, Button, Form, FormGroup, Input, Label, FormFeedback } from 'reactstrap'
import collaboration from './images/graphics/undraw_collaboration2_8og0.svg';
import contact from './images/graphics/undraw_newsletter_vovu.svg';
import Profile from '../components/profile/profile'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class KontaktPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: '',
      email: '',
      message: '',
      budget: '',
      formErrors: { company: '', email: '' },
      companyTouched: false,
      emailTouched: false,
      emailValid: false,
      companyValid: false,
      formValid: false
    };
  }

  handleChange = (e) => {
    const name = e.target.name;
    const touchedName = `${name}Touched`;
    const value = e.target.value;
    this.setState(
      { [name]: value, [touchedName]: true },
      () => { this.validateField(name, value) }
    );
  }

  handleSubmit = e => {
    e.preventDefault();

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...this.state })
    })
      .then(() => navigateTo('/kontakt-danke'))
      .catch(error => alert(error));
  }

  validateField(fieldName, value) {
    let emailValid = this.state.emailValid;
    let companyValid = this.state.companyValid;

    switch (fieldName) {
      case 'email':
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        break;
      case 'company':
        companyValid = value.length >= 1;
        break;
      default:
        break;
    }

    this.setState({
      emailValid: emailValid,
      companyValid: companyValid
    }, this.validateForm);
  }

  validateForm() {
    this.setState({ formValid: this.state.emailValid && this.state.companyValid });
  }

  render() {
    return <div>
      <Helmet
        title={`Senden Sie mir Ihre Projektanfragen oder kontaktieren Sie mich telefonisch.`}
        meta={[
          { name: 'description', content: 'Ich freue mich von Ihren Ideen und Projekten zu hören. Bitte teilen Sie mir noch ein paar Eckdaten mit oder kontaktieren Sie mich telefonisch oder via E-Mail.' },
          { name: 'keywords', content: 'software engineering, softwareentwicklung, Weibern, Haag am Hausruck, Linz, Wels, Grieskirchen, Oberösterreich' },
        ]}
      />

      <section className="sls-block border-bottom bg evelope">
        <div className="bg-image left-40 d-none d-md-block" style={{ backgroundImage: `url(${collaboration})`, backgroundSize: 'contain' }}>
        </div>

        <Container>
          <Row className="align-items-center py-5 py-lg-7 justify-content-end ">
            <Col md="7">
              <h1>Kontakt aufnehmen.</h1>
              <p className="lead my-5">
                Ich freue mich von Ihren Ideen und Projekten zu hören. Bitte teilen Sie mir noch ein paar Eckdaten mit.
              </p>
              <Form method="post" name="contact" data-netlify="true" data-netlify-honeypot="bot-field" onSubmit={this.handleSubmit}>
                <p hidden>
                  <label>
                    Bitte dies freilassen. <input name="bot-field" onChange={this.handleChange} />
                  </label>
                </p>
                <FormGroup>
                  <Label for="company" className="text-uppercase h6">Firma oder Projektname *</Label>
                  <Input type="text" name="company" id="company" onChange={this.handleChange} value={this.state.company} invalid={this.state.companyTouched && !this.state.companyValid} />
                  {this.state.companyTouched && !this.state.companyValid && <FormFeedback>Dieses Feld bitte ausfüllen.</FormFeedback>}
                </FormGroup>
                <FormGroup>
                  <Label for="email" className="text-uppercase h6">Ihre E-Mail Adresse *</Label>
                  <Input type="email" name="email" id="email" onChange={this.handleChange} value={this.state.email} invalid={this.state.emailTouched && !this.state.emailValid} />
                  {this.state.emailTouched && !this.state.emailValid && <FormFeedback>Die Email-Adresse ist ungültig.</FormFeedback>}
                </FormGroup>
                <FormGroup>
                  <Label for="message" className="text-uppercase h6">Ihre Nachricht</Label>
                  <Input type="textarea" name="message" id="message" rows="4" onChange={this.handleChange} value={this.state.message} />
                </FormGroup>
                <FormGroup>
                  <Label for="budget" className="text-uppercase h6">Welchen Budgetrahmen haben Sie sich gesetzt?</Label>
                  <Input type="text" name="budget" id="budget" onChange={this.handleChange} value={this.state.budget} />
                </FormGroup>
                <p className="small">
                  Die angegebenen Daten werden vertraulich behandelt und zum Zweck der Kontaktaufnahme auf unserem Server gespeichert aber niemals für andere Zwecke verwendet.
                </p>
                <Button type="submit" color="primary" disabled={!this.state.formValid}>Absenden</Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row className="align-items-center py-5 py-lg-7">
            <Col md="7" lg="6">
              <Row className="align-items-center mb-6">
                <Col xs="3">
                  <Profile />
                </Col>
                <Col xs="9">
                  <p className="lead p-0 m-0">
                    Sie können mich auch gerne anrufen oder mir eine E-Mail senden.
                  </p>
                </Col>
              </Row>

              <Row>
                <Col xs="6">
                  <h5 className="text-uppercase mt-md-4">Telefon</h5>
                  <p>+43 664 14 555 90</p>

                  <h5 className="text-uppercase mt-md-4">E-Mail</h5>
                  <p>
                    <a href="mailto:thomas@schmidleithner.at">thomas@schmidleithner.at</a>
                  </p>
                </Col>

                <Col xs="6">
                  <h5 className="text-uppercase mt-md-4">Adresse</h5>
                  <address>
                    Grolzham 2D<br />
                    4680 Weibern<br />
                    Austria
                  </address>
                </Col>
              </Row>
            </Col>
            <Col md="5" lg="6">
              <img src={contact} className="img-fluid p-6" alt="Kontakt" />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  }
}

export default KontaktPage



// WEBPACK FOOTER //
// ./src/pages/kontakt.js